module["exports"] = [
  "gmail.com",
  "yahoo.co.kr",
  "hanmail.net",
  "naver.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/internet/free_email.js
// module id = 1351
// module chunks = 0